import React from 'react';
import { Card, CardContent } from "../ui/card";
import { useInvoice } from "../../pages/InvoiceApp";
import { useTheme } from '../ui/theme-provider'; // Import useTheme
import { cn } from '../../lib/utils'; // Import cn

// Fix: Add React.memo and make sure the component is properly exported
export const InvoicePreview = React.memo(() => {
  const {
    previewHtml,
    entries,
    total,
    summary,
    handleGeneratePreview
    //incrementRenderCount
  } = useInvoice();
  const { theme } = useTheme(); // Get theme

  // Track renders
  //incrementRenderCount('preview');

  // Use effect to trigger preview generation only when needed
  React.useEffect(() => {
    if ((!previewHtml || previewHtml.trim() === '') && entries && entries.length > 0) {
      if (typeof handleGeneratePreview === 'function') {
        handleGeneratePreview();
      }
    }
    // eslint-disable-next-line
  }, [previewHtml, entries, handleGeneratePreview]);

  if ((!previewHtml || previewHtml.trim() === '') && entries && entries.length > 0) {
    return (
      <Card className={cn(
        "shadow-lg",
        theme === 'light' ? 'bg-white border-gray-200' : 'bg-[#2A2A3E] border-purple-500/20'
      )}>
        <CardContent className="p-4">
          <h2 className={cn(
            "text-lg font-medium mb-4",
            theme === 'light' ? 'text-black' : 'text-white'
          )}>Invoice Preview</h2>
          <div className={cn(
            'rounded-lg p-4 text-center',
            theme === 'light' ? 'bg-gray-100 text-gray-500' : 'bg-[#1F1F2E] text-gray-400'
          )}>
            Calculating invoice preview...
          </div>
        </CardContent>
      </Card>
    );
  }
  // If no entries, show message
  if (!entries || entries.length === 0) {
    return (
      <Card className={cn(
        "shadow-lg",
        theme === 'light' ? 'bg-white border-gray-200' : 'bg-[#2A2A3E] border-purple-500/20'
      )}>
        <CardContent className="p-4">
          <h2 className={cn(
            "text-lg font-medium mb-4",
            theme === 'light' ? 'text-black' : 'text-white'
          )}>Invoice Preview</h2>
          <div className={cn(
            'rounded-lg p-4 text-center',
            theme === 'light' ? 'bg-gray-100 text-gray-500' : 'bg-[#1F1F2E] text-gray-400'
          )}>
            No invoice entries found. Please enter invoice details to see a preview.
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    // Card: Theme-aware
    <Card className={cn(
      "shadow-lg",
      theme === 'light' ? 'bg-white border-gray-200' : 'bg-[#2A2A3E] border-purple-500/20'
    )}>
      <CardContent className="p-4">
        {/* Title: Theme-aware */}
        <h2 className={cn(
          "text-lg font-medium mb-4",
          theme === 'light' ? 'text-black' : 'text-white'
        )}>Invoice Preview</h2>

        {/* Inner preview area: Keep white background for paper-like preview */}
        <div className="bg-white rounded-lg p-4 overflow-auto max-h-[600px] border border-gray-300">
          <div
            className="invoice-preview"
            dangerouslySetInnerHTML={{ __html: previewHtml }}
          />
        </div>
      </CardContent>
    </Card>
  );
});

// Add default export for consistency with other components
export default InvoicePreview;
